<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('media.edit', { id: vm.$route.params.mediaId })
  }),
  computed: {
    ...mapState('rappersMedia', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('rappers.title'), to: { name: 'rappers.index' } },
      { text: vm.$t('rappers.edit', { id: vm.$route.params.rapperId }), to: { name: 'rappers.edit' } },
      { text: vm.$t('media.title'), to: { name: 'rappers.media.index' } },
      { text: vm.$t('media.edit', { id: vm.$route.params.mediaId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('rappersMedia/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('rappersMedia', ['createItem', 'updateItem'])
  }
}
</script>
